<template>
  <div v-if="isShow" class="pailiantu">
    <div class="pailiantu_box">
      <div :key="data.id" class="pailiantu_pic">
        <a
          v-ptt="['click', 'pface', '拍脸图']"
          href="javascript: false;"
          @touchstart="reportClick(data.id)"
          @click="jumpLinks(data.linkUrl)"
        >
          <img :src="data.hImgUrl" alt />
        </a>
      </div>
      <span
        v-ptt="['close', 'pface', '拍脸图']"
        @click="closePhoto"
      >&times;
      </span>
    </div>
  </div>
</template>
<script>
import { reportSplashScreenBehavior, getSplashScreenData } from '@api/ingame';
import JumpLinksMixin from '@mixins/JumpLinksMixin.ts';

export default {
  name: 'FacePhotoNew',
  mixins: [JumpLinksMixin],
  data() {
    return {
      data: {}, // 渲染数据接收
      isShow: false,
    };
  },
  created() {
    this.getPhotoData();
  },
  methods: {
    reportClick(id) {
      reportSplashScreenBehavior(id, 2);
    },
    // 关闭按钮逻辑
    closePhoto() {
      this.isShow = false;
    },

    // 获取后台数据
    async getPhotoData() {
      try {
        const { data } = await getSplashScreenData();
        if (!data) {
          return;
        }
        const list = data.splashScreenList;
        if (list && list.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          this.data = list[0];
          this.isShow = true;
          reportSplashScreenBehavior(this.data.id, 1);
        } else {
          this.isShow = false;
        }
      } catch (error) {
        console.error(error);
        this.isShow = false;
      }
    },
  },
};
</script>

<style>
.pailiantu {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}

.pailiantu_box {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-height: 4.9rem;
  position: relative;
}

.pailiantu_pic {
  width: auto;
  height: 100%;
  padding: 0.5rem 0;
  overflow: hidden;
}
.pailiantu_pic a{
  display: inline-block;
}
.pailiantu_box .pailiantu_pic a img {
  width: auto;
  max-height: 3.9rem;
}

.pailiantu span {
  margin-left: 0.15rem;
  font-size: 0.6rem;
  color: #fff;
}
</style>
